import { render, staticRenderFns } from "./emotionChart.vue?vue&type=template&id=63fea272&scoped=true"
import script from "./emotionChart.vue?vue&type=script&lang=js"
export * from "./emotionChart.vue?vue&type=script&lang=js"
import style0 from "./emotionChart.vue?vue&type=style&index=0&id=63fea272&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fea272",
  null
  
)

export default component.exports